import Dialog0 from './dialog';
import Content from './Content.vue';
import Data from './Data.vue';
import DownloadTop from './DownloadTop.vue';
import DownloadBottom from './DownloadBottom.vue';
import DownloadHang from './DownloadHang.vue';
import DownloadYearHang from './DownloadYearHang.vue';
import Loading from './Loading.vue';
import Video from './Video.vue';
import NavigationBar from './NavigationBar.vue';
import SafeAreaBottom from './SafeAreaBottom.vue';
import PopupAppShare from './PopupAppShare.vue';
import PopupAppYearShare from './PopupAppYearShare.vue';
import PosterAppShare from './PosterAppShare.vue';
import Thumbnail from './Thumbnail.vue';
import Toast0 from './toast';
import Loading0 from './loading/index';
import Share0 from './share/index';

const components = {
  Content,
  Data,
  DownloadTop,
  DownloadBottom,
  DownloadYearHang,
  DownloadHang,
  Loading,
  Video,
  NavigationBar,
  SafeAreaBottom,
  PopupAppShare,
  PopupAppYearShare,
  PosterAppShare,
  Thumbnail,
};
const prefix = 'Cfmoto';
const install = function install(Vue) {
  if (install.installed) return;
  Object.keys(components).forEach((key) => {
    const componentName = prefix + key;
    Vue.component(componentName, components[key]);
  });
  Vue.config.globalProperties.$loading = Loading0;
  Vue.config.globalProperties.$share = Share0;
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export const Toast = Toast0;
export const Dialog = Dialog0;

export default {
  version: process.env.VERSION, // eslint-disable-line no-undef

  install,
  ...components,
};
